import { recordPath, recordRoute } from '@/shared/registry'

/** Where the enrollment pages live. */
export const enrollmentsPath = '/entitlements/enrollments'
export const createEnrollmentPath = `${enrollmentsPath}/new`
export const enrollmentRoute = recordRoute('entitlements', 'enrollments')
export const editEnrollmentRoute = `${enrollmentRoute}/edit`
export const retakeEnrollmentRoute = `${enrollmentRoute}/retake`

/** An enrollment's details page. */
export function enrollmentPath(id: string): string {
  return recordPath('entitlements', 'enrollments', id)
}

/** An enrollment's edit page. */
export function editEnrollmentPath(id: string): string {
  return `${enrollmentPath(id)}/edit`
}

/** Create Retake: the enrollment's person in another class of the same course. */
export function retakeEnrollmentPath(id: string): string {
  return `${enrollmentPath(id)}/retake`
}

/** Create Enrollment with one person already chosen, as User Details links to it. */
export function createPersonEnrollmentPath(userId: string): string {
  return `${createEnrollmentPath}?${new URLSearchParams({ userId }).toString()}`
}

/**
 * The base of Enrollment Details' slots (`detailsSlots`): Credentials' Skills tab (CRD-14) goes in
 * its `tabs`.
 */
export const enrollmentDetailsSlot = 'entitlements.enrollment-details'

/**
 * The class's activities for the person, on Enrollment Details' Activities tab: Launch's activity
 * list registers here, as a panel given the enrollment's id.
 */
export const enrollmentActivitiesSlot = 'entitlements.enrollment.activities'

/**
 * Classes' per-enrollment panel (completion, grade, connectivity), on Enrollment Details' Overview.
 * The context's record is the enrollment's class; the enrollment is the page's (the route's
 * `publicId`), as Class Details' activity actions are given theirs.
 */
export const enrollmentClassPanelSlot = 'entitlements.enrollment.class-panel'

/** The permissions the enrollment screens show or hide their actions and fields by. */
export const readEnrollmentsPermission = 'entitlements.enrollments.read'
export const writeEnrollmentsPermission = 'entitlements.enrollments.write'
export const deleteEnrollmentsPermission = 'entitlements.enrollments.delete'
export const approveEnrollmentsPermission = 'entitlements.enrollments.approval.write'
export const waitlistEnrollmentsPermission = 'entitlements.enrollments.waitlist.write'
export const retakeEnrollmentsPermission = 'entitlements.enrollments.retake.write'
export const labsEnrollmentsPermission = 'entitlements.enrollments.labs.write'
export const bypassEnrollmentsPermission = 'entitlements.enrollments.prerequisite-bypass.write'

/** The API's enrollment endpoints. */
export const enrollmentsApi = '/entitlements/v1/enrollments'

export function enrollmentApi(id: string): string {
  return `${enrollmentsApi}/${encodeURIComponent(id)}`
}

export function enrollmentStatusApi(id: string): string {
  return `${enrollmentApi(id)}/status`
}

export function enrollmentRetakeApi(id: string): string {
  return `${enrollmentApi(id)}/retake`
}
